/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Michael Kokoulin
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.0
 */
import { createAction } from '../app/createAction';
import {
    LOAD_EXTERNAL_TRANSLATIONS_FAILURE,
    LOAD_EXTERNAL_TRANSLATIONS_FINISH,
    LOAD_EXTERNAL_TRANSLATIONS_START,
    LOAD_EXTERNAL_TRANSLATIONS_SUCCESS,
    LOAD_INTERNAL_TRANSLATIONS_FAIL,
    LOAD_INTERNAL_TRANSLATIONS_START,
    LOAD_INTERNAL_TRANSLATIONS_SUCCESS,
    SET_LOCALE,
    TranslationFileNamesEnum,
} from './constants';
import { ILoadTranslation } from './types';

interface ISetLocale {
    type: typeof SET_LOCALE;
    payload: string;
}

export const setLocale = (locale: string): ISetLocale => createAction(SET_LOCALE, locale);

interface ILoadInternalTranslationsStart {
    type: typeof LOAD_INTERNAL_TRANSLATIONS_START;
    payload: TranslationFileNamesEnum[];
}

export const loadInternalTranslationsStart = (fileNames: TranslationFileNamesEnum[]): ILoadInternalTranslationsStart =>
    createAction(LOAD_INTERNAL_TRANSLATIONS_START, fileNames);

interface ILoadInternalTranslationsSuccess {
    type: typeof LOAD_INTERNAL_TRANSLATIONS_SUCCESS;
    payload: ILoadTranslation;
}

export const loadInternalTranslationsSuccess = (payload: ILoadTranslation): ILoadInternalTranslationsSuccess => {
    return createAction(LOAD_INTERNAL_TRANSLATIONS_SUCCESS, payload);
};

interface ILoadInternalTranslationsFail {
    type: typeof LOAD_INTERNAL_TRANSLATIONS_FAIL;
    payload: string;
}

export const loadInternalTranslationsFail =
    (payload: string): ILoadInternalTranslationsFail => createAction(LOAD_INTERNAL_TRANSLATIONS_FAIL, payload);

export interface ILoadExternalTranslationsStart {
    type: typeof LOAD_EXTERNAL_TRANSLATIONS_START;
}

export const loadExternalTranslationsStart = (): ILoadExternalTranslationsStart => {
    return createAction(LOAD_EXTERNAL_TRANSLATIONS_START);
};

export interface ILoadExternalTranslationsSuccess {
    type: typeof LOAD_EXTERNAL_TRANSLATIONS_SUCCESS;
    payload: { [key: string]: string };
}

export const loadExternalTranslationsSuccess =
    (payload: { [key: string]: string }): ILoadExternalTranslationsSuccess => {
        return createAction(LOAD_EXTERNAL_TRANSLATIONS_SUCCESS, payload);
    };

export interface ILoadExternalTranslationsFailure {
    type: typeof LOAD_EXTERNAL_TRANSLATIONS_FAILURE;
    payload: string;
}

export const loadExternalTranslationsFailure = (payload: string): ILoadExternalTranslationsFailure => {
    return createAction(LOAD_EXTERNAL_TRANSLATIONS_FAILURE, payload);
};

export interface ILoadExternalTranslationsFinish {
    type: typeof LOAD_EXTERNAL_TRANSLATIONS_FINISH;
}

export const loadExternalTranslationsFinish = (): ILoadExternalTranslationsFinish => {
    return createAction(LOAD_EXTERNAL_TRANSLATIONS_FINISH);
};

export type IIntActionTypes =
    | ILoadInternalTranslationsStart
    | ILoadInternalTranslationsSuccess
    | ILoadInternalTranslationsFail
    | ISetLocale
    | ILoadExternalTranslationsSuccess
    | ILoadExternalTranslationsFailure
    | ILoadExternalTranslationsFinish
    | ILoadExternalTranslationsStart;
